<template>
  <div class="row">
    <!-- Last Update-->
    <div class="col-lg">
      <div class="row">
        <div class="col-lg-10">
          <h3>{{ lastUpdate.node }} | Last event : {{ lastUpdate.date }}</h3>
        </div>
        <div class="col-lg-2 text-right">
          <base-dropdown
            menu-classes="dropdown-black"
            title-classes="btn btn-secondary"
            title="More Information"
            menuOnRight
          >
            <a
              class="dropdown-item"
              style="color: white"
              @click="modals.notice = true"
              >Device Information</a
            >
            <a
              @click="viewDataAnalytic(deviceID)"
              class="dropdown-item"
              style="color: white"
              >Data Analytic</a
            >
            <a
              @click="getDeviceLogs()"
              class="dropdown-item"
              style="color: white"
              >Device logs</a
            >
            <a
              @click="LightControlNew('RTC', '1', devicetoken)"
              class="dropdown-item"
              style="color: white"
              >Push RTC Downlink</a
            >
          </base-dropdown>
        </div>
        <modal
          :show.sync="modals.notice"
          footer-classes="justify-content-center"
          type="notice"
        >
          <h3 slot="header" class="modal-title">Device information</h3>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <strong>Device Name</strong>
                <p v-html="deviceName"></p>
              </div>
            </div>
            <!-- </div>
          <div class="modal-body"> -->
            <div class="row">
              <div class="col-md-12">
                <strong>Firmware Version</strong>
                <p v-html="firmwareversion"></p>
              </div>
            </div>
            <!-- </div>
          <div class="modal-body"> -->
            <div class="row">
              <div class="col-md-12">
                <strong>Bottom-board Version</strong>
                <p v-html="bottomversion"></p>
              </div>
            </div>
            <!-- </div>
          <div class="modal-body"> -->
            <div class="row">
              <div class="col-md-12">
                <strong>Top-board Version</strong>
                <p v-html="topversion"></p>
              </div>
            </div>
            <!-- </div>
          <div class="modal-body"> -->
            <div class="row">
              <div class="col-md-12">
                <strong>Device Brand</strong>
                <p v-html="deviceBrand"></p>
              </div>
            </div>
            <!-- </div>
          <div class="modal-body"> -->
            <div class="row">
              <div class="col-md-12">
                <strong>Bluetooth Device ID</strong>
                <p v-html="deviceID"></p>
              </div>
            </div>
            <!-- </div>
          <div class="modal-body"> -->
            <div class="row">
              <div class="col-md-12">
                <strong>Model Number</strong>
                <p v-html="modelNumber"></p>
              </div>
            </div>
            <!-- </div>
          <div class="modal-body"> -->
            <div class="row">
              <div class="col-md-12">
                <strong>Date of Commission</strong>
                <p v-html="dateOfComm"></p>
              </div>
            </div>
            <!-- </div>
          <div class="modal-body"> -->
            <div class="row">
              <div class="col-md-12">
                <strong>Warranty Until</strong>
                <p v-html="warranty"></p>
              </div>
            </div>
          </div>
          <div slot="footer" class="justify-content-center">
            <base-button type="success" @click.native="modals.notice = false"
              >Close</base-button
            >
          </div>
        </modal>

        <modal :show.sync="modals.logs" type="large">
          <template slot="header">
            <h3 class="modal-title" id="exampleModalLabel">Device logs data</h3>
          </template>
          <div>
            <card card-body-classes="table-full-width">
              <div>
                <div
                  class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <!-- <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search Device"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input> -->
                </div>
                <el-table
                  :data="queriedData"
                  :header-cell-style="{
                    background: 'transparent',
                    border: 'transparent',
                    'padding-bottom': '0%',
                    'padding-center': '10px',
                    color: 'white',
                  }"
                  :cell-style="{
                    border: 'transparent',
                    'padding-center': '20px',
                  }"
                >
                  <el-table-column
                    :min-width="150"
                    prop="eventtime"
                    label="Event time"
                  ></el-table-column>
                  <el-table-column
                    :min-width="150"
                    prop="context"
                    label="Context"
                  ></el-table-column>
                  <el-table-column
                    :min-width="150"
                    prop="message"
                    label="Message"
                  ></el-table-column>
                </el-table>
              </div>
              <div
                slot="footer"
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class>
                  <p class="card-category">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                  </p>
                </div>
                <base-pagination
                  class="pagination-no-border"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="total"
                ></base-pagination>
              </div>
            </card>
          </div>
        </modal>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-xl-6 col-lg-12">
          <card type="chart" style="height: 340px">
            <loading
              loader="spinner"
              :height="40"
              :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoadingControl"
              :is-full-page="false"
            ></loading>
            <template>
              <div class="row" style="padding: 15px">
                <!-- Brightness Level -->
                <div class="col-lg-12 col-md-12 inlineControl">
                  <!-- <card type="chart">
                  <template slot="header">-->
                  <h3 class="card-title brightness">
                    <div class="row">
                      <div class="col-lg-12 brightness">
                        <!-- brightness slider -->

                        <veeno
                          class="slider-success"
                          v-model="lightBrightness"
                          :handles="10"
                          :set="lightB"
                          :disabled="disabledBtn"
                          :range="{ min: 10, max: 100 }"
                          :step="10"
                        />
                        <!-- :disabled="disabledBtn" -->
                        <!-- <veeno
                          class="slider-success"
                          v-model="lightBrightness"
                          :handles="10"
                          :range="{ min: 10, max: 100 }"
                          :step="10"
                          :disabled="disabledBtn"
                          @start="LightControl('BRIGHTNESS', '', devicetoken)"
                          @change="
                            LightControl(
                              'BRIGHTNESS',
                              lightBrightness,
                              devicetoken
                            )
                          "
                        /> -->
                        <br />
                      </div>
                    </div>
                  </h3>
                  <div slot="footer"></div>
                  <!-- </template>
                  </card>-->
                </div>

                <div class="col-lg-8">
                  <h5 class="card-category">Brightness Level</h5>
                  <div class="col-lg brightness text-left" style="padding: 0%">
                    <p style="font-size: 30px">{{ lightBrightnessTitle }}%</p>
                  </div>
                </div>

                <!-- Override scheduler -->
                <div class="col-lg-4 col-md-4 inlineControl">
                  <p v-show="active1" style="color: #ffd600; font-size: 10.5px">
                    Scheduler override is ongoing for {{ odcountdown }} minutes
                  </p>
                  <i
                    v-show="odload"
                    class="fas fa-cog fa-spin"
                    style="color: white"
                  ></i>
                  <p v-show="odload" style="color: #ffd600; font-size: 10.5px">
                    &nbsp; Processing...
                  </p>

                  <h5 class="card-category">Override Scheduler</h5>
                  <h3 class="card-title brightness">
                    <div
                      @mouseover="active = true"
                      @mouseleave="active = false"
                    >
                      <el-select
                        class="select-success"
                        size="large"
                        placeholder="Choose..."
                        v-model="selects.simple"
                        @change="handleOverride(selects.simple)"
                        :disabled="disabledDropDown"
                      >
                        <el-option
                          v-for="option in selects.time"
                          class="select-success"
                          :value="option.value"
                          :label="option.label"
                          :key="option.label"
                        ></el-option>
                      </el-select>
                    </div>
                  </h3>
                  <div slot="footer"></div>
                  <!-- </template>
                  </card>-->
                </div>

                <!-- On/Off button -->
                <div class="col-md-6">
                  <!-- <card type="chart">
                  <template slot="header">-->
                  <h5 class="card-category">Node Control</h5>
                  <h3 class="card-title brightness">
                    <!-- <p class="category">Default</p> -->
                    <!-- <base-switch
                  v-model="switches.defaultOn"
                  type="primary"
                  on-text="ON"
                  off-text="OFF"
                    ></base-switch>-->
                    <div>
                      <base-button
                        type="primary"
                        v-on:click="LightControlNew('POWER', 'ON', devicetoken)"
                        :disabled="disabledBtn"
                        ><i v-show="onSpin" class="fas fa-spinner fa-spin"></i>
                        &nbsp;{{ btnOnMsg }}</base-button
                      >
                      &nbsp;&nbsp;
                      <base-button
                        type="danger"
                        v-on:click="
                          LightControlNew('POWER', 'OFF', devicetoken)
                        "
                        :disabled="disabledBtn"
                      >
                        <i v-show="OffSpin" class="fas fa-spinner fa-spin"></i>
                        &nbsp;{{ btnOffMsg }}</base-button
                      >
                    </div>
                    <div slot="footer"></div>
                  </h3>
                  <!-- </template>
                  </card>-->
                </div>
              </div>
            </template>
          </card>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12 col-xs-4">
          <card type="chart" style="height: 340px">
            <loading
              loader="spinner"
              :height="40"
              :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoading"
              :is-full-page="false"
            ></loading>
            <template slot="header">
              <h5 class="card-category"></h5>
              <h3 class="card-title">
                <!-- map -->
                <div id="map" class="map">
                  <l-map
                    ref="map"
                    id="toto"
                    style="height: 300px"
                    :zoom="zoom"
                    :center="center"
                    class="sidebar-map"
                    :options="{ scrollWheelZoom: false }"
                    v-for="center in center"
                    :key="center.addCenter"
                  >
                    <l-tile-layer
                      :url="url"
                      :attribution="attribution"
                    ></l-tile-layer>
                    <l-marker
                      :icon="markerIcon"
                      :lat-lng="marker"
                      v-for="marker in markers"
                      :key="marker.addMarker"
                    >
                      <l-popup>
                        <div>
                          <h4 style="color: black">{{ marker }}</h4>
                        </div>
                      </l-popup>
                    </l-marker>
                  </l-map>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-xl-6 col-lg-12">
          <div class="row">
            <!-- Connection Status -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-xs-6">
              <stats-card
                :title="connectedTime"
                :sub-title="connectionTitle"
                :icon="connectionStatus"
                style="height: 155px"
              >
                <div slot="footer">
                  <div>
                    <p>
                      Node RSSI: &nbsp; {{ lorarssi }}
                      <br />
                      Gateway RSSI: &nbsp; {{ gatewayrssi }}
                    </p>
                  </div>
                </div>
              </stats-card>
            </div>

            <!-- Bluetooth Status -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-xs-6">
              <stats-card
                :title="noConnectedBluetoothDevice"
                :sub-title="bluetoothTitle"
                :icon="bluetoothStatus"
                style="height: 155px"
              >
                <div slot="footer">
                  <div stlye>
                    <p class="abc">RSSI: &nbsp; {{ blrssi }}</p>
                  </div>
                </div>
              </stats-card>
            </div>

            <!-- Light Status -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-xs-6">
              <stats-card
                :title="switches"
                :sub-title="statusTitle"
                :icon="switchIcon"
                style="height: 155px"
              ></stats-card>
            </div>

            <!-- Light Brigthness -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-xs-6">
              <stats-card
                :title="lightBrightnessTitle"
                :sub-title="brightnessTitle"
                :icon="brightnessIcon"
                style="height: 155px"
              ></stats-card>
            </div>
          </div>

          <div class="row">
            <!-- Last Voltage -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-xs-6">
              <stats-card
                :title="lastVoltage"
                :sub-title="voltageTitle"
                :icon="voltageIcon"
                style="height: 155px"
              ></stats-card>
            </div>
            <!-- Last Current -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-xs-6">
              <stats-card
                :title="lastCurrent"
                :sub-title="currentTitle"
                :icon="currentIcon"
                style="height: 155px"
              ></stats-card>
            </div>
            <!-- Total Energy -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-xs-6">
              <stats-card
                :title="totalEnergy"
                :sub-title="energyTitle"
                :icon="energyIcon"
                style="height: 155px"
              ></stats-card>
            </div>
            <!-- Schedule Profile -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-xs-6">
              <stats-card
                :title="scheduleProfile"
                :sub-title="scheduleTitle"
                :icon="scheduleIcon"
                style="height: 155px"
              ></stats-card>
            </div>
          </div>
        </div>
        <!-- Hourly Voltage -->
        <div class="col-lg-6 col-xs-6">
          <card type="card-chart" style="height: 340px" no-footer-line>
            <loading
              loader="spinner"
              :height="40"
              :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoading2"
              :is-full-page="false"
            ></loading>
            <template slot="header">
              <h5 class="card-category">Hourly Voltage (V)</h5>
              <h3 class="card-title">
                <div class="chart-area">
                  <line-chart
                    v-if="lineChart1.loaded"
                    :chart-data="lineChart1.chartData"
                    :gradient-colors="lineChart1.gradientColors"
                    :gradient-stops="lineChart1.gradientStops"
                    :extra-options="lineChart1.extraOptions"
                    :height="250"
                  ></line-chart>
                </div>
                <div class="chartButton">
                  <!-- <base-button type="success">24 hours</base-button>
                  <base-button type="success">7 days</base-button>-->
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>

        <!-- Hourly Current -->
        <div class="col-lg-6 col-xs-6">
          <card type="card-chart" no-footer-line>
            <loading
              loader="spinner"
              :height="40"
              :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoading2"
              :is-full-page="false"
            ></loading>
            <template slot="header">
              <h5 class="card-category">Hourly Current (mA)</h5>
              <h3 class="card-title">
                <div class="chart-area">
                  <line-chart
                    v-if="lineChart2.loaded"
                    :chart-data="lineChart2.chartData"
                    :gradient-colors="lineChart2.gradientColors"
                    :gradient-stops="lineChart2.gradientStops"
                    :extra-options="lineChart2.extraOptions"
                    :height="250"
                  ></line-chart>
                </div>
                <div class="chartButton">
                  <!-- <base-button type="success">24 hours</base-button>
                  <base-button type="success">7 days</base-button>-->
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>

        <!-- Hourly Energy Usage -->
        <div class="col-lg-6 col-xs-6 d-flex">
          <card type="card-chart" no-footer-line>
            <loading
              loader="spinner"
              :height="40"
              :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoading2"
              :is-full-page="false"
            ></loading>
            <template slot="header">
              <h5 class="card-category">Hourly Energy Usage (Kwh)</h5>
              <h3 class="card-title">
                <div class="chart-area">
                  <line-chart
                    v-if="lineChart3.loaded"
                    :chart-data="lineChart3.chartData"
                    :gradient-colors="lineChart3.gradientColors"
                    :gradient-stops="lineChart3.gradientStops"
                    :extra-options="lineChart3.extraOptions"
                    :height="250"
                  ></line-chart>
                </div>
                <div class="chartButton">
                  <!-- <base-button type="success">24 hours</base-button>
                  <base-button type="success">7 days</base-button>-->
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>
        <!-- Nearby Devices -->
        <!-- <div class="col-lg-6 col-md-6">
          <card type="chart" card-body-classes="table-full-width">
            <template slot="header">
              <h5 class="card-category">In Range Devices</h5>
        <h3 class="card-title brightness">-->
        <!-- table -->
        <!-- <h4 slot="header" class="card-title">Paginated Tables</h4> -->
        <!-- <div>
                  <div
                    class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                  >
                    <el-select
                      class="select-primary mb-3 pagination-select"
                      v-model="pagination.perPage"
                      placeholder="Per page"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>

                    <base-input>
                      <el-input
                        type="search"
                        class="mb-3 search-input"
                        clearable
                        prefix-icon="el-icon-search"
                        placeholder="Search records"
                        v-model="searchQuery"
                        aria-controls="datatables"
                      ></el-input>
                    </base-input>
                  </div>
                  <el-table :data="queriedData">
                    <el-table-column
                      v-for="column in tableColumns"
                      :key="column.label"
                      :min-width="column.minWidth"
                      :prop="column.prop"
                      :label="column.label"
                    ></el-table-column>
                  </el-table>
                </div>
                <div
                  slot="footer"
                  class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <div class>
                    <p
                      class="card-category"
                    >Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
                  </div>
                  <base-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                  ></base-pagination>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>-->

        <!-- Node Log -->
        <!-- <div class="col-lg-6 col-md-6">
          <card type="chart" card-body-classes="table-full-width">
            <template slot="header">
              <h5 class="card-category">Node Log</h5>
        <h3 class="card-title brightness">-->
        <!-- table -->
        <!-- <h4 slot="header" class="card-title">Paginated Tables</h4> -->
        <!-- <div>
                  <div
                    class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                  >
                    <el-select
                      class="select-primary mb-3 pagination-select"
                      v-model="pagination.perPage"
                      placeholder="Per page"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>

                    <base-input>
                      <el-input
                        type="search"
                        class="mb-3 search-input"
                        clearable
                        prefix-icon="el-icon-search"
                        placeholder="Search records"
                        v-model="searchQuery"
                        aria-controls="datatables"
                      ></el-input>
                    </base-input>
                  </div>
                  <el-table :data="queriedData">
                    <el-table-column
                      v-for="column in tableColumns"
                      :key="column.label"
                      :min-width="column.minWidth"
                      :prop="column.prop"
                      :label="column.label"
                    ></el-table-column>
                  </el-table>
                </div>
                <div
                  slot="footer"
                  class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <div class>
                    <p
                      class="card-category"
                    >Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
                  </div>
                  <base-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                  ></base-pagination>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { Modal, BasePagination, BaseDropdown } from "src/components";

// For displaying Line Chart
import BarChart from "@/components/Charts/BarChart";
import LineChart from "@/components/Charts/LineChart";
import * as chartConfigs from "@/components/Charts/config";
import StatsCard from "src/components/Cards/StatsCard";
import config from "@/config";

// For Slider and Switch
import { Table, TableColumn, Select, Option } from "element-ui";
import { Slider, BaseSwitch } from "src/components/index";
import CountryMapCard from "./CountryMapCard";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import veeno from "veeno";
// import "nouislider/distribute/nouislider.min.css";

// Data Table
import TaskList from "./TaskList";
import UserTable from "./UserTable";
import users from "./users"; //read users from this file
import moment from "moment";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Map
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
} from "vue2-leaflet";
import { parse } from "path";

export default {
  components: {
    Loading,
    Modal,
    BasePagination,
    LineChart,
    BarChart,
    StatsCard,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseSwitch,
    Slider,
    CountryMapCard,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    TaskList,
    UserTable,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    BaseDropdown,
    veeno,
  },
  data() {
    return {
      isLoading: false,
      isLoading2: false,
      isLoadingControl: true,
      //onoff button
      btnOnMsg: "Turn On",
      btnOffMsg: "Turn Off",
      onSpin: false,
      OffSpin: false,
      WaitSocket: false,
      socketData: null,
      lastCommandSend: null,
      lockFailed: false,
      notAllowed: true,
      lastTxTS: 0,

      //overdrive
      ttlod: 0,
      od_time_end: null,
      active1: false,
      odload: false,
      //control
      disabledBtn: false,
      active: false,

      disabledDropDown: false,
      test: 0,
      lockCount: 0,
      lockSend: 0,
      lockSendOnOD: 0,
      // Connection Status
      connectionTitle: "Connection Status",
      connectedTime: "Offline",
      status: null,
      // connectionStatus: require("@/assets/img/NB-IoT Icon.png"),
      connectionStatus: null,

      // Bluetooth Status
      bluetoothTitle: "InRange BT Node",
      noConnectedBluetoothDevice: "0",
      bluetoothStatus: require("@/assets/img/Bluetooth.png"),

      // Last Voltage
      voltageTitle: "Last Voltage (V)",
      lastVoltage: "0",
      voltageIcon: require("@/assets/img/Voltage Icon.png"),

      // Last Current
      currentTitle: "Last Current (mA)",
      lastCurrent: "0",
      currentIcon: require("@/assets/img/Current Icon.png"),

      // Total Energy
      energyTitle: "Total Energy (Kwh)",
      totalEnergy: "0",
      energyIcon: require("@/assets/img/Energy Icon.png"),

      // Light Status
      statusTitle: "Light Status",
      switches: "Off",
      switchIcon: require("@/assets/img/Light Status.png"),
      devicetoken: "",
      devicetype: "",
      // Light Brightness
      brightnessTitle: "Light Brightness",
      lightBrightnessTitle: "0",
      brightnessIcon: require("@/assets/img/Light Brightness.png"),
      lightBrightness: 0,
      lightB: 0,
      brightness: null,

      // Schedule Profile
      scheduleTitle: "Schedule Profile",
      scheduleProfile: "Not Available",
      scheduleIcon: require("@/assets/img/Calendar Icon.png"),
      footer: "RSSI",

      //RSSI
      lorarssi: "0",
      blrssi: "0",
      gatewayrssi: "0",

      // Slider
      slider: {
        start: 50,
        range: { min: 10, max: 100 },
      },
      selects: {
        simple: "",
        time: [
          { value: "30", label: "30 Min" },
          { value: "60", label: "60 Min" },
          { value: "1", label: "1 Min" },
        ],
        multiple: "ARS",
      },
      overrideSchedule: "45",

      lastUpdate: {
        node: "",
        date: "Not Available",
      },
      cacheTime: "Not Available",

      // Device Information
      deviceName: "Not Available",
      deviceBrand: "Not Available",
      deviceID: "Not Available",
      BluetoothID: "Not Supported",
      modelNumber: "Not Available",
      dateOfComm: "1/8/2019",
      warranty: "1/8/2020",
      firmwareversion: "Not Available",
      topversion: "Not Available",
      bottomversion: "Not Available",
      connType: "",
      modals: {
        notice: false,
        logs: false,
      },

      // Map
      zoom: 18,
      center: [],
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [],

      // Hourly Voltage chart
      lineChart1: {
        chartData: {
          labels: [0, 0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },

      // Hourly Current
      lineChart2: {
        chartData: {
          labels: [0, 0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },

      // Hourly Energy Usage
      lineChart3: {
        chartData: {
          labels: [0, 0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },

      // Data Table
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Device", "signalstrength"],
      tableColumns: [
        {
          prop: "device",
          label: "Device",
          minWidth: 200,
        },
        // {
        //   prop: "deviceType",
        //   label: "DeviceType"
        // },
        {
          prop: "signalstrength",
          label: "SignalStrength",
          minWidth: 250,
        },
        // {
        //   prop: 'age',
        //   label: 'Age',
        //   minWidth: 100
        // },
        // {
        //   prop: 'salary',
        //   label: 'Salary',
        //   minWidth: 120
        // }
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      bright: null,
    };
  },

  computed: {
    odcountdown() {
      let self = this;

      if (this.active1) {
        this.renderCountDown();
      } else {
        clearInterval();
      }
      return this.ttlod;
    },
    setHandle() {
      
      return this.brightness;
    },
    markerIcon() {
      return L.icon({
        iconUrl: require("@/assets/img/100 Brightness.png"),
        shadowUrl: require("@/assets/img/marker-shadow.png"),

        iconSize: [35, 35], // size of the icon
        // shadowSize: [50, 30], // size of the shadow
        iconAnchor: [10, 5], // point of the icon which will correspond to marker's location
        shadowAnchor: [15, 5], // the same for the shadow
        // popupAnchor: [-3, -76] // point from which the po
      });
    },
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  beforeDestroy() {
   
    this.socket.close();
    
  },
  methods: {
    getDeviceDetails() {
      let deviceid = this.$route.params.deviceid;
      this.deviceID = deviceid;

      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/device/" + deviceid)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            
          } else {
         

            // data
            let deviceData = res.message.deviceinfo[0];

            // assign token
            this.devicetoken = deviceData.devicetoken;

            // assign value
            this.devicetype = deviceData.devicetype;
            this.center.push(L.latLng(deviceData.lat, deviceData.lon));
            this.markers.push(L.latLng(deviceData.lat, deviceData.lon));

            // assign correct logo to Connection Status card
            this.checkDeviceType(this.devicetype);

            // assign node name to last updated data (top line)
            this.lastUpdate.node = deviceData.devicename;

            //init socket data
            this.getSocketData();
            this.isLoadingControl = false;

            //call graph data
            this.callData2();

            //get last node state
            this.getLastLightStatus();

            //update information

            this.deviceName = deviceData.devicename;
            this.deviceBrand = deviceData.devicebrand;
            this.modelNumber = deviceData.devicemodel;
            this.dateOfComm = deviceData.commdate == "" ? "-": deviceData.commdate;
            this.warranty = deviceData.warranty == "" ? "-": deviceData.warranty;
            this.firmwareversion = deviceData.firmrev;
            this.topversion = deviceData.tbrev;
            this.bottomversion = deviceData.bbrev;
            this.connType = deviceData.connection_type;
            this.isLoading = false;

            //call device status
            this.LightControlNew("INITCALL", "RT", this.devicetoken);
          }
        })
        .catch((err) => {
        
        });
    },
    handleOverride(min) {
      swal({
        title: "Are you sure?",
        text: `You want to edit override schedule to ${this.selects.simple} min`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.odload = true;
          this.detectScheduler(min);
        } else {
          this.selects.simple = "";
        }
      });
    },
    renderCountDown() {
      this.test = setInterval(() => {
        // let timenow = moment().add(1, "hours");
        // let timenow = moment(moment(), "hh:mm:ss").utcOffset(0);
        let testtime = moment.utc();
        let timenow = moment(testtime.format("HH:mm:ss"), "HH:mm:ss");
        let endtime = moment(this.od_time_end, "HH:mm:ss");
        let beza = endtime.diff(timenow);
        if (beza < 0) {
          this.active1 = false;
          this.disabledBtn = true;
          this.disabledDropDown = false;
          this.selects.simple = "";
          clearInterval();
        } else {
          this.ttlod = moment.utc(beza).format("HH:mm:ss");
         
        }
      }, 1000);
    },
    checkOverride() {
      if (!this.notAllowed) {
        var url = ":8004/api/v1/overdrive/" + this.deviceID + "";

        this.$http
          .get(url)
          .then((res) => {
            if (res.error) {
              swal({
                type: "error",
                title: "Oops... Something went wrong!",
                text: res.message,
              });
              this.message = res.message;
            } else {
              this.message = res.message;
            
              if (this.message.length > 0) {
                this.active1 = true;
                this.ttlod = res.message[0].od_time;
                this.disabledDropDown = true;
                this.disabledBtn = false;
                this.od_time_end = res.message[0].end_time;
                this.lockCount = 1;
                this.renderCountDown();
              } else {
                this.disabledBtn = true;
                this.disabledDropDown = false;
              }
            }
            //
          })
          .catch((err) => {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: err,
            });
          });
      } else {
        this.disabledBtn = true;
        this.disabledDropDown = true;
      }
    },
    detectScheduler(min) {
     
      var url = ":8004/api/v1/overdrive/device/" + this.deviceID + "/" + min;

      this.$http
        .post(url)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          } else {
           
            this.message = res.message;
            swal({
              type: "success",
              title: "Changes Submitted!",
              text: res.message,
            });
          }
          this.disabledDropDown = true;
          this.disabledBtn = false;
          this.lockCount = 1;
          this.odload = false;
          this.checkOverride();
        })
        .catch((err) => {
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: err,
          });
        });
    },
    getDeviceLogs() {
      var url = ":8007/api/v1/log/" + this.deviceID + "";

      this.$http.get(url).then((res) => {
        if (res.error) {
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: res.message,
          });
        } else {
         
          this.tableData = [];
          for (let i = 0; i < res.message.length; i++) {
            let obj = {};
            obj["eventtime"] = moment(res.message[i].createdAt).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            obj["context"] = res.message[i].LogContext;
            obj["message"] = res.message[i].LogMessage;
            this.tableData.push(obj);
          }

          // this.tableData = res.message;
          this.modals.logs = true;
        }
        //
      });
    },
    checkDeviceType(devtype) {
     
      switch (devtype) {
        case "lora":
          this.connectionStatus = require("@/assets/img/LoRa Icon.png");
          break;
        case "nbiot":
          this.connectionStatus = require("@/assets/img/NB-IoT Icon.png");
          break;
        default:
        
      }
    },
    viewDataAnalytic(d) {
      const deviceIDAnalytic = d;
      this.$router.push({ path: `/dataanalyticlight/${deviceIDAnalytic}` });
    },
    checkConncetionStat(time) {
      let currentTime = parseInt(Date.now() / 1000);

      if (time > currentTime - 3600) {
        this.connectedTime = "Online";
      } else {
        this.connectedTime = "Offline";
      }
    },
    checkLightStatus(status) {
      if (status == 1) {
        this.switches = "On";
      } else {
        this.switches = "Off";
      }
    },
    getLastLightStatus() {
    
      let payload = {
        devicelist: [this.devicetoken],
      };

      this.$http
        .post(":8001/api/v1/telemetry/device/status/beta/lights", payload)
        .then((res) => {
          if (res.error) {
          } else {
           
            this.lastTxTS = res.message[0].last_tx_hourly;
          }
        });
    },
    getSocketData() {
      let url = process.env.VUE_APP_WS_URL;
      
      this.socket = new WebSocket(
        url + ":8001/api/v1/telemetry/device/lights/" + this.devicetoken + "/ws"
      );
      this.socket.onopen = () => {
        this.status = "connected";

        this.socket.onmessage = ({ data }) => {
          let final = JSON.parse(data);
         
          this.socketData = final;
          let lrrssi,
            brssi,
            gwrssi = "";
          if (final.voltage != null) {
            this.lastVoltage = final.voltage[0].value.toString();
            this.totalEnergy = (final.energy[0].value / 1000)
              .toFixed(2)
              .toString();
            this.lastCurrent = final.current[0].value.toString();
            this.checkLightStatus(final.status[0].value);
            this.checkConncetionStat(final.status[0].timestamp);
            let bright = final.dimm[0].value * 10;

            if (this.connectedTime != "Offline") {
              this.lightBrightnessTitle = bright.toString() + ".00";

              if (this.lightBrightnessTitle !== bright.toString() + ".00") {
                this.lightBrightnessTitle = bright.toString() + ".00";
              }

              if (this.lockCount === 0) {
                this.lightB = parseInt(bright);
              }

              if (this.active1 == true && this.lockSendOnOD === 0) {
                this.lightB = parseInt(bright);
              }

              if (
                final.lorarssi[0].value === 0 &&
                final.gwrssi[0].value === 0
              ) {
                lrrssi = final.lorarssi[0].value;
              } else {
                lrrssi = "- " + final.lorarssi[0].value.toString();
                gwrssi = "- " + final.gwrssi[0].value.toString();
                // blrssi = "- " + final.blrssi[0].value;
              }

              if (final.blrssi[0].value === 0) {
                brssi = "Not supported";
              } else {
                brssi = "- " + final.blrssi[0].value.toString();
                // blrssi = "- " + final.blrssi[0].value;
              }

              if (final.schedule[0].value === 1) {
                this.scheduleProfile = "Weekdays";
              } else if (final.schedule[0].value === 2) {
                this.scheduleProfile = "Weekends";
              } else if (final.schedule[0].value === 3) {
                this.scheduleProfile = "Holidays";
              } else {
                this.scheduleProfile = "Not Available";
              }

              this.blrssi = brssi;
              this.lorarssi = lrrssi;
              this.gatewayrssi = gwrssi;
            } else {
              this.blrssi = 0;
              this.lorarssi = 0;
              this.gatewayrssi = 0;
              this.lastCurrent = 0;
              this.totalEnergy = 0;
              this.lastVoltage = 0;
              this.switches = "Off";
              this.lightBrightnessTitle = 0;
            }

            // SET LAST NODE UPDATE
          
            
            moment().diff(moment.unix(final.voltage[0].timestamp), "minutes") <=
            60
              ? (this.lastUpdate.date = moment
                  .unix(final.voltage[0].timestamp)
                  .fromNow())
              : (this.lastUpdate.date =
                  this.cacheTime !== "Not Available"
                    ? moment.unix(this.cacheTime).fromNow()
                    : moment.unix(this.lastTxTS).fromNow());
          } else {
            if (this.lastTxTS == "0") {
              this.lastUpdate.date = "Not Available";
            } else {
              this.lastUpdate.date = moment.unix().fromNow();
            }
          }
        };
      };
    },
    LightControlNew(controlType, controlValue, clusterID) {
      var urlAPI = ":8003/api/v1/control/light/unicast/" + this.devicetoken;

      let value = controlType;

      

      if (controlType == "INITCALL") {
        let param2 = {
          conntype: this.connType,
          context: "CONTROL",
          command: [
            {
              data: "RT",
            },
          ],
        };

        this.$http.post(urlAPI, param2).then((res) => {});
      } else if (controlType == "RTC") {
        let param2 = {
          conntype: this.connType,
          context: "RTC",
          command: [
            {
              data: "1",
            },
          ],
        };

        this.$http.post(urlAPI, param2).then((res) => {});
      } else {
        let param = {
          conntype: this.connType,
          context: "CONTROL",
          command: [
            {
              data: controlValue,
            },
          ],
        };

        let param2 = {
          conntype: this.devicetype,
          context: "CONTROL",
          command: [
            {
              data: "RT",
            },
          ],
        };

     

        this.$http.post(urlAPI, param).then((res) => {});

        //request data after 1 second
        setTimeout(() => {
          
          this.$http.post(urlAPI, param2).then((res) => {});
        }, 5000);
      }
    },
    LightControl(controlType, controlValue, devID) {
  
      var self = this;
      // for server in cloud
      var urlAPI =
        ":8003/v1/api/control/light/unicast/" + devID + "/" + this.deviceID;

      let set = false;
      // let previousVal = this.lightBrightness;

      var param = "";

      if (controlType == "POWER") {
        param = controlValue;

        if (param == "AQEBBQ==") {
          //if on
        
          this.btnOnMsg = "Loading..";
          this.onSpin = true;
          this.disabledBtn = true;
          this.lastCommandSend = param;
        } else if (param == "AQEABQ==") {
          //if off
       
          this.btnOffMsg = "Loading..";
          this.OffSpin = true;
          this.disabledBtn = true;
          this.lastCommandSend = param;
        }
      } else if (controlType == "BRIGHTNESS") {
        switch (controlValue) {
          case "10.00":
            param = "AQEBAQ==";
            break;
          case "20.00":
            param = "AQEBAg==";
            break;
          case "30.00":
            param = "AQEBAw==";
            break;
          case "40.00":
            param = "AQEBBA==";
            break;
          case "50.00":
            param = "AQEBBQ==";
            break;
          case "60.00":
            param = "AQEBBg==";
            break;
          case "70.00":
            param = "AQEBBw==";
            break;
          case "80.00":
            param = "AQEBCA==";
            break;
          case "90.00":
            param = "AQEBCQ==";
            break;
          case "100.00":
            param = "AQEBCg==";
            break;
          default:
          
        }
      } else if (controlType == "INITCALL") {
        //request 0c
        let data2 = [
          {
            deviceQueueItem: {
              confirmed: false,
              fPort: 3,
              devEUI: devID,
              data: "DA==",
            },
          },
        ];

        //send
        this.$http.post(urlAPI, data2).then((res) => {
       
        });
      }

      if (controlType == "POWER" || controlType == "BRIGHTNESS") {
        let data = [
          {
            deviceQueueItem: {
              confirmed: false,
              fPort: 3,
              devEUI: devID,
              data: param,
            },
          },
        ];
        this.$http.post(urlAPI, data).then((res) => {
         
        });

        //request 0c
        let data2 = [
          {
            deviceQueueItem: {
              confirmed: false,
              fPort: 3,
              devEUI: devID,
              data: "DA==",
            },
          },
        ];

        //send
        this.$http.post(urlAPI, data2).then((res) => {
        
        });
      }
    },
    initLine1(param, data) {
      let avr = 0;
      let devData = null;
      let date = null;
      let timeStamp = [];
      let dataValue = [];

      for (let i = 0; i < data.length; i++) {
        devData = data[i].value;
        date = data[i].timestamp;
        if (param == "voltage") {
          timeStamp.push(moment.unix(date).format("h:mm a")); //toLocaleTimeString javascript method //x-axis
          dataValue.push(devData); //y-axis
        } else if (param == "current") {
          timeStamp.push(moment.unix(date).format("h:mm a")); //toLocaleTimeString javascript method //x-axis
          dataValue.push(devData); //y-axis
        } else if (param == "energy") {
          timeStamp.push(moment.unix(date).format("h:mm a")); //toLocaleTimeString javascript method //x-axis
          dataValue.push(devData / 1000); //y-axis
        }
      }

      // let nextHour = moment(timeStamp[timeStamp.length - 1], "h:mm a").format(
      //   "h:mm a"
      // );
      // let balanceHour = 24 - timeStamp.length;

      // for (let i = 0; i < balanceHour; i++) {
      //   timeStamp.push(nextHour);
      //   nextHour = moment(nextHour, "h:mm a").add(1, "hours").format("h:mm a");
      // }

      let chart = {
        chartData: {
          labels: timeStamp,
          datasets: [
            {
              label: "Hourly " + param,
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: dataValue,
            },
          ],
        },
        extraOptions: chartConfigs.energyChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };

      if (param == "voltage") {
        this.lineChart1 = chart;
      } else if (param == "current") {
        this.lineChart2 = chart;
      } else if (param == "energy") {
        this.lineChart3 = chart;
      }
      this.isLoading2 = false;
    },
    callData2() {
      this.lineChart1.loaded = false;
      this.lineChart2.loaded = false;
      this.lineChart3.loaded = false;
      var self = this;
      let payload = {
        type: "lights",
        params: ["current", "energy", "voltage", "status", "power", "dimm"],
      };

      let today = moment().unix();
      let later = moment().startOf("day").unix();
      

      this.$http
        .post(
          ":8001/api/v1/telemetry/device/test/lights/" +
            this.devicetoken +
            "/" +
            later +
            "/" +
            today +
            "",
          payload
        )
        .then((res) => {
          if (res.message.voltage == null) {
            this.resetChart("voltage");
            this.resetChart("current");
            this.resetChart("energy");
          } else {
            //get cached data
            this.cacheTime =
              res.message.voltage[res.message.voltage.length - 1].timestamp;
            this.initLine1("voltage", res.message.voltage);
            this.initLine1("current", res.message.current);
            this.initLine1("energy", res.message.energy);
          }
        });
    },
    resetChart(param) {
      let timeStamp = [];
      let today = moment().startOf("day").format("hh:mm a");

      for (let i = 0; i < 24; i++) {
        timeStamp.push(today);
        today = moment(today, "hh:mm a").add(1, "hours").format("hh:mm a");
      }

      let chart = {
        chartData: {
          labels: timeStamp,
          datasets: [
            {
              label: "Weekly " + param,
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };

      if (param == "voltage") {
        this.lineChart1 = chart;
      } else if (param == "current") {
        this.lineChart2 = chart;
      } else if (param == "energy") {
        this.lineChart3 = chart;
      }
    },
  },

  mounted() {
    // Fuse search initialization.
    this.lightBrightnessTitle = this.lightBrightness;
  },
  created() {
    this.isLoading = true;
    this.isLoading2 = true;
    this.isLoadingControl = true;
    // push default date/time to graph
    let currentDate = moment().format("h:mm a");
    let defaultGraph = [];
    defaultGraph.push(currentDate);

    // *
    for (let i = 1; i < 7; i++) {
      let previousDate = moment().subtract(i, "hours").format("h:mm a");
      defaultGraph.push(previousDate);
    }

    // reverse the order of the array(X-axis)
    this.lineChart1.chartData.labels = defaultGraph.reverse();
    this.lineChart2.chartData.labels = defaultGraph.reverse();
    this.lineChart3.chartData.labels = defaultGraph.reverse();

    
    this.getDeviceDetails();
    this.checkOverride();

    //get last mode state

    //Check permission (TEMP)
    let scope = [];
    let jwt_token = this.$cookie.get("token").split(".")[1];
    jwt_token = JSON.parse(atob(jwt_token));
    let user_scope = jwt_token["UserScopes"];
    for (let i = 0; i < user_scope.length; i++) {
      scope.push(user_scope[i]);
      
      for (let j = 0; j < scope.length; j++) {
        if (scope[j] === "admin.control" || scope[j] === "device.control") {
          this.disabledBtn = false;
          this.notAllowed = false;
          this.checkOverride();
        }
      }
    }
  },
  watch: {
    //send data slider
    // socketData() {
    //   let self = this;
    //   if (this.onSpin === true || this.OffSpin === true) {
    //     if (!this.lockFalse) {
    //       let final = this.socketData;
    //       let a = moment(moment(), "hh:mm:ss");
    //       let b = moment(moment.unix(final.voltage[0].timestamp), "hh:mm:ss");
    //       let c = a.diff(b, "hours");

  

    //       if (c > 0) {
    //         this.lockFalse = true;

    //         swal({
    //           title: "No Response from node",
    //           text: `Would to like to perform retry ?`,
    //           type: "error",
    //           showCancelButton: true,
    //           confirmButtonClass: "btn btn-success btn-fill",
    //           cancelButtonClass: "btn btn-danger btn-fill",
    //           confirmButtonText: "Yes",
    //           cancelButtonText: "No",
    //           buttonsStyling: false
    //         }).then(result => {
    //           if (result.value) {
    //             this.LightControl(
    //               "POWER",
    //               this.lastCommandSend,
    //               this.devicetoken
    //             );
    //             this.lockFalse = false;
    //           } else {
    //             if (this.onSpin) {
    //               this.onSpin = false;
    //               this.btnOnMsg = "Turn On";
    //               this.disabledBtn = false;
    //               this.lastCommandSend = null;
    //             } else if (this.OffSpin) {
    //               this.OffSpin = false;
    //               this.btnOffMsg = "Turn Off";
    //               this.disabledBtn = false;
    //               this.lastCommandSend = null;
    //             }
    //             this.lockFalse = false;
    //           }
    //         });
    //       } else {
    //         if (this.onSpin) {
    //           this.onSpin = false;
    //           this.btnOnMsg = "Turn On";
    //           this.disabledBtn = false;
    //           this.lastCommandSend = null;
    //         } else if (this.OffSpin) {
    //           this.OffSpin = false;
    //           this.btnOffMsg = "Turn Off";
    //           this.disabledBtn = false;
    //           this.lastCommandSend = null;
    //         }
    //         this.lockFalse = false;
    //       }
    //     }
    //   }
    // },
    lightBrightness() {
      let self = this;
    
      clearTimeout(this.test);
     
      if (this.lockCount == 0) {
      
      } else {
        swal({
          title: "Are you sure?",
          text: `You want to set brightness to ${this.lightBrightness}`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, edit it!",
          buttonsStyling: false,
        }).then((result) => {
          if (
            (this.lightBrightness !== "" &&
              this.lightBrightness != this.lightBrightnessTitle) ||
            this.lockSendOnOD === 1
          ) {
            clearTimeout(this.test);
            this.test = setTimeout(() => {
             
              let value = this.lightBrightness;
              this.LightControlNew(
                "BRIGHTNESS",
                parseInt(value, 10).toString(),
                this.devicetoken
              );
            }, 5000);
          }

          if (this.active1) {
            this.lockSendOnOD = 1;
          }
          this.lightBrightnessTitle = this.lightBrightness;
        });

        // this.lightB = parseInt(this.lightBrightness);
        // display brightness data in card
        // this.lightBrightnessTitle = this.lightBrightness;
      }
    },
    searchQuery(value) {
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["context", "message", "eventtime"],
        threshold: 0.3,
      });
      let result = this.tableData;
     
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
   
    },
  },
};
</script>

<style scoped>
.head h3 {
  display: inline;
  padding-bottom: 10px;
}
.brightness p {
  display: inline;
}
/* .bright slider {
  display: inline;
} */
.chartButton {
  text-align: right;
}
.inlineControl p {
  display: inline;
}
.pos p {
  text-align: right;
  font-size: 14px;
}
div.col-left {
  max-width: 40px;
}
.card-category {
  font-size: 12px;
}
.slider {
  color: aqua;
}
@media (max-height: 1000px) {
  .col-xs-6 {
    min-height: 50%;
    height: 50%;
  }
}
</style>
